import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import Link from 'components/shared/Link/Link';
import ExternalLink from 'components/shared/ExternalLink/ExternalLink';

const btnBaseCss = ({ fullWidth }) => css`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-weight: 500;

  :not(:disabled) {
    cursor: pointer;
  }

  // Remove highlighted background when tapping on a button using touch actions
  -webkit-tap-highlight-color: transparent;

  // Remove outline when clicked but not focused,
  // keeping focus indication when navigated by a keyboard
  :not(:focus-visible) {
    :focus {
      outline: none;
    }
  }

  ${fullWidth &&
  css`
    width: 100%;
  `}
`;

const btnIconCss = css`
  display: inline-flex;
`;

const startIconCss = css`
  margin-right: 5px;
`;

const endIconCss = css`
  margin-left: 5px;
`;

function ButtonBase({
  as: Component = 'button',
  children,
  endIcon,
  fullWidth,
  startIcon,
  type = 'button',
  ...restProps
}) {
  return (
    <Component
      css={btnBaseCss({ fullWidth })}
      type={Component === 'button' ? type : undefined}
      {...restProps}
    >
      {startIcon && <span css={[btnIconCss, startIconCss]}>{startIcon}</span>}
      <span>{children}</span>
      {endIcon && <span css={[btnIconCss, endIconCss]}>{endIcon}</span>}
    </Component>
  );
}

ButtonBase.propTypes = {
  as: PropTypes.oneOf(['button', ExternalLink, Link]),
  children: PropTypes.node,
  endIcon: PropTypes.node,
  fullWidth: PropTypes.bool,
  startIcon: PropTypes.node,
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
};

export default ButtonBase;
